import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { Col, FormGroup, Label, Input } from 'reactstrap';
import ReCAPTCHA from 'react-recaptcha';
import SimpleReactValidator from 'simple-react-validator';
import { DropDownInput } from '../../inputs/DropDownInput';
import { dataLayerPush } from '../../../helpers';
import ExpandableTextarea from '../ExpandableTextarea/ExpandableTextarea';
import PhoneNumberInput from '../PhoneNumberUtility/PhoneNumberInput';
import { useHistory, useLocation } from 'react-router';

const TEST_SITE_KEY = '6LeyNfoSAAAAAPb-dogoo24hW1Ah4rn8g6Vb9o_z';

const options = [
    {
        data: 'fileClaim',
        display: 'Fila A Claim'
    },
    {
        data: 'generalInfo',
        display: 'General Information'
    },
    {
        data: 'trackClaim',
        display: 'Track Claim'
    },
    {
        data: 'uploadDoc',
        display: 'Upload a Document'
    }
];

const njrOptions = [
    {
        data: 'claimSatus',
        display: 'Claim Status'
    },
    {
        data: 'fileClaim',
        display: 'File Claim'
    },

    {
        data: 'generalInfo',
        display: 'General Information'
    },
    {
        data: 'purchasePlan',
        display: 'Purchase a Plan'
    }
];

const validator = new SimpleReactValidator({
    element: (message) => (
        <div
            className='errorMsg'
            aria-live='polite'
        >
            {message.charAt(0).toUpperCase() + message.slice(1)}
        </div>
    ),
    messages: {
        required: ':attribute is required.',
        phone: 'Please enter a valid phone number.'
    },
    validators: {
        valid_phone: {
            message: 'Please enter a valid phone number.',
            rule: (val, params, validator) => {
                return !new RegExp('^([0-9])\\1{9}$').test(val.match(/\d+/g).join(''));
            }
        }
    }
});

const descValidator = new SimpleReactValidator({
    element: (message) => (
        <div
            className='errorMsg'
            aria-live='polite'
        >
            {message.charAt(0).toUpperCase() + message.slice(1)}
        </div>
    ),
    messages: {
        required: ':attribute are required.'
    }
});

export function ContactUsForm(props) {
    const history = useHistory();
    const { bothNames = false, isApple = false, descMaxLength = '500' } = props;
    const [selectedOption, setSelectedOption] = useState('');
    const [showDropDownError, setShowDropDownError] = useState(false);
    const [name, setName] = useState('');
    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setphone] = useState('');
    const [caseId, setcaseId] = useState('');
    const [incidentDescription, setIncidentDescription] = useState('');
    const [value, setValue] = useState('');
    const [wordCount, setWordCount] = useState(0);
    const [showCaptchaError, setShowCaptchaError] = useState(false);

    useEffect(() => {
        // FOR GTM ANALYTICS
        console.log(history);
        dataLayerPush('/vendor/apple/contactus', 'Contact Us');
    }, []);

    const fetchtheAgentPortalHostname = (url) => {
        if (url.includes('localhost')) {
            return 'https://localhost:44385';
        } else if (url.includes('dev')) {
            return 'https://dev.warrantyinfoservhub.com';
        } else if (url.includes('qa')) {
            return 'https://qa.warrantyinfoservhub.com';
        } else {
            return 'https://warrantyinfoservhub.com';
        }
    };

    const continueNext = useCallback(
        (e) => {
            e.preventDefault();
            //console.log(e, validator, descValidator, validator.allValid(), descValidator.allValid());
            setShowDropDownError(!selectedOption);
            if (validator.allValid() && descValidator.allValid()) {
                console.log(value);
                if (isApple === true) {
                    if (value) {
                        setShowCaptchaError(false);
                        fetch('api/communication/GetRecipientsforTheftandLostEmail/'.concat('apple'))
                            .then((res) => res.json())
                            .then((recipients) => {
                                console.log(recipients);

                                // sending Contact Us Email notification
                                fetch('api/communication/'.concat('apple'), {
                                    method: 'post',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        emailModel: {
                                            //Recipients: ['vakavaram@sndirect.com'],

                                            Recipients: recipients,
                                            Cc: [],
                                            Bcc: [],
                                            IsBodyHtml: true,
                                            emailType: 18
                                        },
                                        serviceModel: {
                                            CustomerName: bothNames ? `${fname} ${lname}` : name,
                                            CustomerContactReason: selectedOption,
                                            CustomerEmail: email,
                                            CustomerPhone:
                                                phone.length === 14
                                                    ? phone
                                                    : phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3'),
                                            CustomerAdditionalDescription: incidentDescription,
                                            CustomerViewContract:
                                                fetchtheAgentPortalHostname(window.location.origin)
                                                + '/?caseId='
                                                + caseId,
                                            CustomerDispatchIdOrCaseNumber: caseId,
                                            CaseNumber: caseId
                                        }
                                    })
                                }).then((res) => {
                                    console.log(res);
                                    const statusCode = res.status;
                                    const url = '/vendor/apple/ContactConfirmation/';
                                    history.push(url, { caseId: caseId });
                                    return res.json();
                                });
                            });
                    } else {
                        setShowCaptchaError(true);
                    }
                }
                ///NJR
                else {
                    if (value) {
                        setShowCaptchaError(false);
                        fetch('api/communication/GetRecipientsforTheftandLostEmail/'.concat('njr'))
                            .then((res) => res.json())
                            .then((recipients) => {
                                console.log(recipients);

                                //Check Party details by Email if exists party then update
                                //Else send mail
                                fetch('api/party/GetPartyByEmail/'.concat('njr'), {
                                    method: 'post',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        emailModel: {
                                            Recipients: recipients,
                                            Cc: [],
                                            Bcc: [],
                                            IsBodyHtml: true,
                                            emailType: 18
                                        },
                                        serviceModel: {
                                            CustomerName: bothNames ? `${fname} ${lname}` : name,
                                            CustomerContactReason: selectedOption,
                                            CustomerEmail: email,
                                            CustomerPhone:
                                                phone.length === 14
                                                    ? phone
                                                    : phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3'),
                                            CustomerAdditionalDescription: incidentDescription
                                        }
                                    })
                                }).then((res) => {
                                    console.log(res);
                                    const statusCode = res.status;
                                    console.log(res.json());
                                });

                                // sending Contact Us Email notification
                                fetch('api/communication/'.concat('njr'), {
                                    method: 'post',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        emailModel: {
                                            Recipients: recipients,
                                            Cc: [],
                                            Bcc: [],
                                            IsBodyHtml: true,
                                            emailType: 51
                                        },
                                        serviceModel: {
                                            CustomerName: bothNames ? `${fname} ${lname}` : name,
                                            CustomerContactReason: njrOptions.filter(
                                                (o) => o.data === selectedOption
                                            )[0]?.display,
                                            CustomerEmail: email,
                                            CustomerPhone:
                                                phone.length === 14
                                                    ? phone
                                                    : phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3'),
                                            CustomerAdditionalDescription: incidentDescription
                                        }
                                    })
                                }).then((res) => {
                                    console.log(res);
                                    const statusCode = res.status;

                                    //Need to write logic for redirecting toconformation Page

                                    const url = '/confirmation/1';
                                    history.push(url);
                                    return res.json();
                                });
                            });
                    } else {
                        setShowCaptchaError(true);
                    }
                }
            } else {
                validator.showMessages();
                descValidator.showMessages();
                // rerender to show messages for the first time
                // you can use the autoForceUpdate option to do this automatically`
                // this.forceUpdate();
            }
        },
        [selectedOption, setShowDropDownError, value, setShowCaptchaError, email, phone, incidentDescription, caseId]
    );

    const handleChange = useCallback(
        (value) => {
            console.log('Captcha value:', value);
            if (value !== null) {
                setValue(value);
                setShowCaptchaError(false);
            }
            // if value is null recaptcha expired
            // if (value === null) this.setState({ expired: "true" });
        },
        [setValue, setShowCaptchaError]
    );

    const handleDescription = useCallback(
        (e) => {
            const count = e.target.value;
            const wordCount = count.split('').length;
            setWordCount(wordCount);
            setIncidentDescription(count);
        },
        [setWordCount, setIncidentDescription]
    );

    const handleStateDropDown = useCallback(
        (e) => {
            console.log(e);
            setSelectedOption(e);
            setShowDropDownError(false);
        },
        [setSelectedOption, setShowDropDownError]
    );

    const emailError = validator.message('email', email, 'required|email');
    const fnameError = validator.message('last name', fname, 'required');
    const lnameError = validator.message('last name', lname, 'required');
    const nameError = validator.message('name', fname, 'required');
    const phoneError = validator.message('phone', phone, 'required|phone|valid_phone');
    //const caseIdError = validator.message("caseId", caseId, "required");
    const descError = validator.message('incidentDescription', incidentDescription, 'required');
    const CommentsError = descValidator.message('questionsOrComments', incidentDescription, 'required');

    return (
        <div>
            <Col className='mb-2 p-0'>
                <FormGroup className={showDropDownError ? 'form-error' : ''}>
                    <label
                        htmlFor='helpOptions'
                        className='form-label font-weight-bold'
                    >
                        How can we help?
                    </label>
                    <span
                        aria-hidden='true'
                        className='required-indicator'
                    >
                        *
                    </span>

                    <DropDownInput
                        name='helptype'
                        options={isApple ? options : njrOptions}
                        className='form-control'
                        onChangedValue={handleStateDropDown}
                        placeholder='Please select...'
                        id='helpOptions'
                    />

                    {showDropDownError && <div className='errorMsg'>Please select an option.</div>}
                </FormGroup>

                {bothNames ? (
                    <Fragment>
                        <FormGroup className={fnameError ? 'form-error' : ''}>
                            <Label
                                htmlFor='firstName'
                                className='form-label font-weight-bold'
                            >
                                First Name
                            </Label>
                            <span
                                aria-hidden='true'
                                className='required-indicator'
                            >
                                *
                            </span>
                            <Input
                                type='text'
                                name='fname'
                                className='form-control'
                                value={fname}
                                id='firstName'
                                placeholder=''
                                onChange={(e) => setFname(e.target.value)}
                            />
                            {fnameError}
                        </FormGroup>
                        <FormGroup className={lnameError ? 'form-error' : ''}>
                            <Label
                                htmlFor='lastName'
                                className='form-label font-weight-bold'
                            >
                                Last Name
                            </Label>
                            <span
                                aria-hidden='true'
                                className='required-indicator'
                            >
                                *
                            </span>
                            <Input
                                type='text'
                                name='lname'
                                className='form-control'
                                value={lname}
                                id='lastName'
                                placeholder=''
                                onChange={(e) => setLname(e.target.value)}
                            />
                            {lnameError}
                        </FormGroup>
                    </Fragment>
                ) : (
                    <FormGroup className={nameError ? 'form-error' : ''}>
                        <Label
                            htmlFor='name'
                            className='form-label font-weight-bold'
                        >
                            Name
                        </Label>
                        <span
                            aria-hidden='true'
                            className='required-indicator'
                        >
                            *
                        </span>
                        <Input
                            type='text'
                            name='name'
                            className='form-control'
                            value={name}
                            id='name'
                            placeholder=''
                            onChange={(e) => setName(e.target.value)}
                        />
                        {nameError}
                    </FormGroup>
                )}
                <FormGroup className={emailError ? 'form-error' : ''}>
                    <Label
                        htmlFor='email'
                        className='form-label font-weight-bold'
                    >
                        Email
                    </Label>
                    <span
                        aria-hidden='true'
                        className='required-indicator'
                    >
                        *
                    </span>
                    <Input
                        type='text'
                        name='email'
                        className='form-control'
                        value={email}
                        id='email'
                        placeholder=''
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    {emailError}
                </FormGroup>
                <FormGroup className={phoneError ? 'form-error' : ''}>
                    <PhoneNumberInput
                        fieldName='contactPhone'
                        label='Phone'
                        value={phone}
                        onChange={(e) => setphone(e.target.value)}
                        error={phoneError}
                    />
                </FormGroup>

                <FormGroup className={descError ? 'form-error' : ''}>
                    <Label
                        htmlFor='Comments'
                        className='form-label font-weight-bold'
                    >
                        {isApple ? 'Please provide a detailed description of your question.' : 'Questions or Comments'}
                    </Label>
                    <span
                        aria-hidden='true'
                        className='required-indicator'
                    >
                        *
                    </span>
                    <ExpandableTextarea
                        value={incidentDescription}
                        maxLength={descMaxLength}
                        onChange={handleDescription}
                        id='Comments'
                    />
                    {isApple ? (
                        <div className='d-flex justify-content-between'>{descError}</div>
                    ) : (
                        <div className='d-flex justify-content-between'>{CommentsError}</div>
                    )}
                </FormGroup>
            </Col>
            <Col
                lg='5'
                className='p-0'
            >
                <ReCAPTCHA
                    sitekey={TEST_SITE_KEY}
                    render='explicit'
                    verifyCallback={handleChange}
                />
                {showCaptchaError && <div className='errorMsg'>Please check above option.</div>}

                <button
                    className='btn btn-primary mb-5'
                    style={{ marginTop: '3.5rem' }}
                    onClick={continueNext}
                >
                    Submit
                </button>
            </Col>
        </div>
    );
}
